export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12844.27ec9838.jpg";